var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.984009,
    width: 37.024,
    height: 37.024,
    rx: 10.68,
    fill: "#916145"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.3464 14.995C28.3577 15.1531 28.3577 15.3113 28.3577 15.4694C28.3577 20.2921 24.687 25.8489 17.9781 25.8489C15.9112 25.8489 13.9912 25.2503 12.3761 24.2113C12.6698 24.2451 12.9521 24.2564 13.2571 24.2564C14.9625 24.2564 16.5324 23.6804 17.7861 22.6978C16.1823 22.6639 14.8383 21.6135 14.3752 20.1678C14.6011 20.2017 14.827 20.2243 15.0642 20.2243C15.3917 20.2243 15.7193 20.1791 16.0242 20.1001C14.3526 19.7612 13.0989 18.293 13.0989 16.5197V16.4746C13.5846 16.7456 14.1493 16.9151 14.7479 16.9376C13.7653 16.2825 13.1215 15.1644 13.1215 13.8994C13.1215 13.2218 13.3022 12.6006 13.6184 12.0584C15.4143 14.2721 18.1136 15.7178 21.1405 15.876C21.0841 15.6049 21.0502 15.3226 21.0502 15.0402C21.0502 13.0298 22.6766 11.3921 24.6983 11.3921C25.7486 11.3921 26.6973 11.8326 27.3637 12.5441C28.1882 12.386 28.9788 12.081 29.6791 11.6632C29.408 12.5103 28.832 13.2218 28.0753 13.6735C28.8094 13.5945 29.521 13.3912 30.176 13.1089C29.6792 13.8317 29.0579 14.4754 28.3464 14.995Z",
    fill: "#F2F7F7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.2c379a868cd222e46761cf4df12bdc17.svg";
export { ForwardRef as ReactComponent };